// extracted by mini-css-extract-plugin
export default {"wrapper":"CompetenceVerificationTypeCell_wrapper__PHIhn"};